import { Text, Box, VStack, Badge } from '@chakra-ui/react';

import { useColorModeValue } from "../../../components/ui/color-mode";

export const FeatureCircle = ({ title, description, icon: IconComp, colorScheme, isComingSoon = false }) => {
    const iconBg = useColorModeValue("primary.50", "primary.900");
    const descColor = useColorModeValue("gray.600", "gray.400");

    return (
        <VStack position="relative" gap={2} maxW={{ base: "140px", md: "180px" }}>
            {isComingSoon && (
                <Badge
                    backgroundColor="orange"
                    color="black"
                    position="absolute"
                    top="12%"
                    left="50%"
                    transform="translate(-50%, -50%) rotate(-18deg)"
                    zIndex="banner"
                    variant="solid"
                    px={2}
                    py={1}
                    fontSize="xs"
                >
                    Coming Soon
                </Badge>
            )}
            <Box
                borderRadius="full"
                p={4}
                display="flex"
                alignItems="center"
                justifyContent="center"
                bg={iconBg}
                borderWidth={2}
                borderColor={colorScheme}
                aria-label={title}
            >
                <Box display="flex" alignItems="center" justifyContent="center" color={colorScheme}>
                    <IconComp size={36} />
                </Box>
            </Box>
            <Text fontWeight="semibold" fontSize="sm" textAlign="center" lineHeight="1.3">
                {title}
            </Text>
            {description && (
                <Text fontSize="xs" textAlign="center" color={descColor} lineHeight="1.4">
                    {description}
                </Text>
            )}
        </VStack>
    );
};
